import { ProgressContext } from '@/contexts/ProgressContext';
import { useContext } from 'react';

export function useProgress() {
  const { progress, setProgress } = useContext(ProgressContext);

  return {
    progress,
    setProgress,
  };
}
